import React, { useState } from 'react';
import CaretIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import Popper from '@mui/material/Popper';
import { FlexDiv } from '../design-system/containers';
import { ThemedButton } from './themed-button/ThemedButton';
import { TextDefault } from '../design-system/texts';

// exemplary usage:
// <DropdownThemedButton
//     text="Create assessment"
//     wrapperProps={{ flexGrow: 1 }}
//     btnProps={{ mode: 'primary' }}
//     items={[
//         {
//             text: 'Assessment',
//             props: {
//                 component: Link,
//                 to: '/assessment/create',
//             },
//         },
//         {
//             text: 'Assessment (SCORM, cmi5)',
//             props: {
//                 component: 'a',
//                 href: demoLink,
//                 target: '_blank',
//                 rel: 'noreferrer',
//             },
//         },
//     ]}
// />;

export const DropdownThemedButton = ({
    text,
    wrapperProps,
    btnProps,
    items,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClickAway = () => {
        setAnchorEl(false);
    };

    const dropdownOpen = Boolean(anchorEl);

    const dropdownItems =
        items &&
        items.map((x, i) => (
            <MenuItem key={i} {...x.props}>
                <TextDefault bold padding={4}>
                    {x.text}
                </TextDefault>
            </MenuItem>
        ));

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <FlexDiv positionRelative {...wrapperProps}>
                <ThemedButton {...btnProps} 
                size="fullWidth" 
                onClick={handleClick}
                text={
                    <>
                    {text} <CaretIcon fontSize="small" />
                    </> }
                />
                <Popper
                    open={dropdownOpen}
                    anchorEl={anchorEl}
                    disablePortal
                    placement="bottom-start"
                    style={{
                        minWidth: '100%',
                        paddingTop: 4,
                        paddingBottom: 4,
                        zIndex: 100,
                    }}
                >
                    <FlexDiv
                        column
                        backgroundColor="white"
                        style={{
                            boxShadow:
                                '0px 0px 4px rgba(0, 0, 0, 0.04), 0px 4px 24px rgba(29, 30, 29, 0.08)',
                        }}
                        borderRadius={4}
                        py={16}
                        onClick={handleClickAway}
                    >
                        {dropdownItems}
                    </FlexDiv>
                </Popper>
            </FlexDiv>
        </ClickAwayListener>
    );
};
